import React from "react";
import { MediakitDataProvider } from "./MediakitDataProvider";
import Visor from "./Visor";
import styles from "./MediakitV2.module.scss";

function MediakitV2() {
  return (
    <div className={styles.root}>
      <MediakitDataProvider>
        <Visor />
      </MediakitDataProvider>
    </div>
  );
}

export default MediakitV2;
